module.exports = __webpack_public_path__ + "static/img/Damien-Cook.43c1dbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Damien-Cook.jpg
// module id = C4if
// module chunks = 0